const urlRoot = '/customers';

export const URL = {
    create: urlRoot,
    createAmazon: `${urlRoot}/amazon`,
    customer: `${urlRoot}/{id}`,
    auth: `${urlRoot}/auth`,
    refresh: `${urlRoot}/auth/refresh`,
    reset: `${urlRoot}/reset-password`,
    activateSmartcard: `${urlRoot}/{id}/smartcard/activate`,
    findSeasonTickets: `${urlRoot}/{id}/ticket-search`,
    identityProvider: `${urlRoot}/auth/{provider}/{id}`,
    transferSeasonTicket: `${urlRoot}/{id}/product-swap`,
    preferences: `${urlRoot}/{id}/preferences`,
    postCodeLookUp: `${urlRoot}/address/postcode-lookup`,
    setPasswordAndPreferences: `${urlRoot}/set-password-and-preferences`,
    validateBacs: `${urlRoot}/validation/bacs-lookup`,
    checkEmail: `${urlRoot}/email`,
    deleteCustomer: `${urlRoot}/{id}/deactivate`,
    cancelDeletionRequest: `${urlRoot}/{id}/deactivate/{requestId}/cancel`,
};



// WEBPACK FOOTER //
// ./src/helpers/CustomerEndpoint.js